module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/LeCreuset-7513dc6bf4d4192bd680934c5a2bd6f4.png";